<template>
    <nav class="main-menu">
        <div class="container">
            <ul class="list float-right">
                <li v-for="menu in navbarmenu" class="list-item list-item-has-children mega-menu mega-menu-col-5">
                    <a class="nav-link" href="#" :title="menu.title">{{menu.title}}</a>
                    <ul class="sub-menu">
                        <li>
                            <div v-for="item in menu.items.slice(0, 10)">
                                <router-link v-if="item.type == 'SubGroup'" :title="item.title" :to="{ name: 'filter' , query: { SubGroupId: item.id , SubGroupName: item.title.replace(/\s+/g, '-') }}" class="subgroupsClass"><i class="fa fa-angle-left"></i>{{item.title}}</router-link>
                                <router-link v-else :title="item.subGroupName" :to="{name: 'filter' , query:{ CategoryId: item.id , CategoryName: item.title.replace(/\s+/g, '-') , SubGroupName: item.subGroupName.replace(/\s+/g, '-') , SubGroupId: item.subGroupId}}" class="categoryClass">{{item.title}}</router-link>
                            </div>
                        </li>
                        <li>
                            <div v-for="item in menu.items.slice(10, 20)">
                                <router-link v-if="item.type == 'SubGroup'" :title="item.title" :to="{ name: 'filter' , query: { SubGroupId: item.id , SubGroupName: item.title.replace(/\s+/g, '-') }}" class="subgroupsClass"><i class="fa fa-angle-left"></i>{{item.title}}</router-link>
                                <router-link v-else :title="item.subGroupName" :to="{name: 'filter' , query:{ CategoryId: item.id , CategoryName: item.title.replace(/\s+/g, '-') , SubGroupName: item.subGroupName.replace(/\s+/g, '-') , SubGroupId: item.subGroupId}}" class="categoryClass">{{item.title}}</router-link>
                            </div>
                        </li>
                        <li>
                            <div v-for="item in menu.items.slice(20, 30)">
                                <router-link v-if="item.type == 'SubGroup'" :to="{ name: 'filter' , query: { SubGroupId: item.id , SubGroupName: item.title.replace(/\s+/g, '-') }}" class="subgroupsClass"><i class="fa fa-angle-left"></i>{{item.title}}</router-link>
                                <router-link v-else :to="{name: 'filter' , query:{ CategoryId: item.id , CategoryName: item.title.replace(/\s+/g, '-') , SubGroupName: item.subGroupName.replace(/\s+/g, '-') , SubGroupId: item.subGroupId}}" class="categoryClass">{{item.title}}</router-link>
                            </div>
                        </li>
                        <li>
                            <div v-for="item in menu.items.slice(30, 40)">
                                <router-link v-if="item.type == 'SubGroup'" :to="{ name: 'filter' , query: { SubGroupId: item.id , SubGroupName: item.title.replace(/\s+/g, '-') }}" class="subgroupsClass"><i class="fa fa-angle-left"></i>{{item.title}}</router-link>
                                <router-link v-else :to="{name: 'filter' , query:{ CategoryId: item.id , CategoryName: item.title.replace(/\s+/g, '-') , SubGroupName: item.subGroupName.replace(/\s+/g, '-') , SubGroupId: item.subGroupId}}" class="categoryClass">{{item.title}}</router-link>
                            </div>
                        </li>

                    </ul>
                </li>
                <li class="list-item amazing-item">
                    <router-link to="/" class="nav-link">صفحه اصلی</router-link>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>
    export default {
        computed: {
            navbarmenu: function () {
                return this.$store.getters.readNavbarmenu;
            }
        },
        methods: {
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-image-available.png";
            },
        }
    }
</script>

<style scoped>
    header.main-header .main-menu .list > .list-item > a {
        color: #575349 !important;
    }
    header.main-header .main-menu .list .amazing-item {
        float: left;
        background-color: #575349;
    }
        header.main-header .main-menu .list .amazing-item > a {
            color: #fff !important
        }
    header.main-header .main-menu .list > .list-item > a, header.main-header .main-menu .list > .list-item > span {
        color: #1e1c1c;
    }

    header.main-header .main-menu {
        width: 100%;
        float: right;
        background: #ffc103;
        margin-top: 15px;
        border-bottom: unset;
    }

    .fa-angle-left {
        color: #00bfd6;
        font-size: 16px;
        padding-left: 3px;
        vertical-align: sub;
    }

    header.main-header .main-menu .list .list-item.mega-menu.mega-menu-col-5 li {
        width: 22.65%;
    }

    header.main-header .main-menu .list .list-item.mega-menu > .sub-menu > li {
        padding-right: 15px;
    }

        header.main-header .main-menu .list .list-item.mega-menu > .sub-menu > li > div > a.categoryClass {
            border-bottom: none !important;
        }

        header.main-header .main-menu .list .list-item.mega-menu > .sub-menu > li > div > a.categoryClass {
            padding-right: 10px;
            display: inline;
            padding: 4px 35px;
            color: #6a6a6a;
            font-size: 12px;
            line-height: 2.27;
            font-weight: 500;
            transition: all .3s;
        }

            header.main-header .main-menu .list .list-item.mega-menu > .sub-menu > li > div > a.categoryClass:hover {
                color: #000 !important;
                border-bottom: none;
                transition: all .3s;
            }
</style>